<!-- Dialog title -->
<h1 mat-dialog-title>
  <div class="flex flex-row items-center">
    <div
      class="flex flex-row items-center mx-2 justify-center bg-accent-900 rounded-full h-10 w-10"
    >
      <mat-icon class="icon-size-5" color="primary" svgIcon="mat_solid:share"></mat-icon>
    </div>
    <span class="text-primary">{{ 'Share' | transloco }}</span>
  </div>
</h1>
<mat-divider></mat-divider>

<!-- Dialog body -->
<form [formGroup]="shareForm" class="space-y-4">
  <div class="mt-4">
    <!-- Text field for the current link -->
    <div>
      <mat-form-field class="w-full">
        <mat-label>{{ 'Page Link' | transloco }}</mat-label>
        <input
          [value]="currentLink"
          class="text-secondary"
          id="txtCurrentLink"
          matInput
          readonly
          type="text"
        />
        <button
          mat-icon-button
          id="btnCopyLink"
          matSuffix
          class="ms-2"
          (click)="copyLink()"
          [matTooltip]="'Copy Link' | transloco"
        >
          <mat-icon svgIcon="mat_solid:content_copy"></mat-icon>
        </button>
      </mat-form-field>
      <p *ngIf="copySuccess" class="text-green-500 text-sm mb-2" id="txtCopyLinkMsg">
        {{ 'Link copied to clipboard' | transloco }}
      </p>
    </div>

    <!-- Email Input with Add Button -->
    <div>
      <mat-form-field class="w-full">
        <mat-label>{{ 'Email' | transloco }}</mat-label>
        <input
          matInput
          formControlName="email"
          id="txtEmailInput"
          type="email"
          class="text-secondary"
          [placeholder]="'Enter Email' | transloco"
        />
        <button
          mat-icon-button
          id="btnAddEmail"
          matSuffix
          (click)="addEmail()"
          [matTooltip]="'Add email' | transloco"
        >
          <mat-icon svgIcon="mat_solid:add"></mat-icon>
        </button>
        <mat-error
          id="txtEmailValidation"
          *ngIf="
            shareForm.get('email')?.invalid &&
            shareForm.get('email')?.touched &&
            shareForm.get('email')?.getError('pattern')
          "
        >
          {{ 'Please enter a valid email.' | transloco }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Chips for displaying added emails -->
    <div class="flex flex-wrap items-center gap-2 mt-2">
      <div
        *ngFor="let email of emails"
        class="flex items-center px-2 py-1 text-sm font-medium text-accent-400 bg-accent-700 rounded-full"
      >
        <span id="txtEnteredEmail">
          {{ email }}
        </span>
        <button
          (click)="removeEmail(email)"
          class="ml-2 flex items-center text-red-500"
          id="btnRemoveEmail"
        >
          <mat-icon class="icon-size-5" svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Dialog actions -->
<div mat-dialog-actions class="flex justify-end">
  <button mat-dialog-close class="mat-dense">
    {{ 'Cancel' | transloco }}
  </button>
  <button
    (click)="sendEmail()"
    class="mat-dense ms-2"
    color="primary"
    id="btnSendEmail"
    mat-raised-button
  >
    {{ 'Send' | transloco }}
  </button>
</div>
